import FieldEditorModal from './FieldEditorModal/FieldEditorModal';
import {
  FieldEditorSubmit,
  SourceFieldOption
} from '../helpers/articleTypeConfig.types';

type Props = {
  isOpen: boolean;
  defaultValues?: FieldEditorSubmit;
  sourceFieldOptions: SourceFieldOption[];
  mandatoryFieldNames: readonly string[];
  onClose: () => void;
  onSave: (values: FieldEditorSubmit) => void;
};

const EditFieldModal: React.FC<Props> = ({
  isOpen,
  defaultValues,
  sourceFieldOptions,
  mandatoryFieldNames,
  onClose,
  onSave
}) => (
  <FieldEditorModal
    isOpen={isOpen}
    mode="edit"
    defaultValues={defaultValues}
    sourceFieldOptions={sourceFieldOptions}
    mandatoryFieldNames={mandatoryFieldNames}
    onClose={onClose}
    onSave={onSave}
  />
);

export default EditFieldModal;
